import * as React from "react";
function SvgWhatsapp(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4 12a8 8 0 114.4 7.147l-.212-.108H4.96v-3.227l-.107-.213A7.966 7.966 0 014 12zm8-10C6.477 2 2 6.477 2 12a9.967 9.967 0 00.96 4.281v4.758H7.72A9.965 9.965 0 0012 22c5.523 0 10-4.477 10-10S17.523 2 12 2zm-1.979 5.526l.909.908a1 1 0 010 1.415l-.611.61s-.086.794.797 1.678c.884.883 2.03 1.151 2.03 1.151l.612-.611a1 1 0 011.414 0l.909.908c.213.214.43.48.246.72-.096.123-.24.287-.457.503-.925.925-1.325.988-1.325.988s-2.316.969-5.01-1.725c-2.693-2.694-1.725-5.01-1.725-5.01s.063-.399.989-1.324a5.5 5.5 0 01.504-.457c.239-.185.505.033.718.246z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgWhatsapp);
export default ForwardRef;
